import type { CSSProperties, MouseEventHandler } from "react";

export function CarouselHeading({
  name,
  description,
  nameClassName = "component-name",
  descriptionClassName = "component-description",
  nameStyle,
  descriptionStyle,
  onNameClick,
}: {
  name?: string;
  description?: string | null;
  nameClassName?: string;
  descriptionClassName?: string;
  nameStyle?: CSSProperties;
  descriptionStyle?: CSSProperties;
  onNameClick?: MouseEventHandler<HTMLParagraphElement>;
}) {
  const desc = String(description || "").trim();
  return (
    <div className="component-header-individual">
      <p className={nameClassName} style={nameStyle} onClick={onNameClick}>
        {name}
      </p>
      {desc ? (
        <p className={descriptionClassName} style={descriptionStyle}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}
